import { createContext } from 'react';
// These types define the shape of the data coming from the database services.
import { PageRevision } from '@/tripod/db/page-db-service';
import { FragmentWithRevisions } from '@/tripod/views/FeedFragmentEditorView';
import { TabContainer } from '@moment/shared-code/tab-container.ts';

// This defines the shape of the data injected by the server for live previews.
export interface TripodContextData {
  pageData?: {
    revision: PageRevision;
    fragments: Record<string, FragmentWithRevisions>;
  };
  pageDataMap?: Record<
    string,
    {
      revision: PageRevision;
      fragments: Record<string, FragmentWithRevisions>;
    }
  >;
  dynamicRoutes?: any[];
  tabContainers?: TabContainer[];
  runtimeConfig?: RuntimeConfigValue;
}

export interface RuntimeConfigValue {
  [key: string]: Record<string, string>;
}

export interface TripodContextValue {
  tripodData?: TripodContextData;
  isLoading: boolean;
  setTripodData: (data: TripodContextData) => void;
}

export const TripodContext = createContext<TripodContextValue | undefined>(
  undefined
);
